export enum FieldLabels {
  SELECT_NAME = 'brandName',
  SELECT_PLACEHOLDER = 'Brand name',
  SELECT_LABEL = 'Brand',

  TEXT_NAME = 'category',
  TEXT_PLACEHOLDER = 'Category',
}

export enum ButtonLabels {
  CONFIRM = 'Create',
  UPDATE = 'Update',
  CANCEL = 'Cancel',
}

export enum CreateBrandModalProps {
  HEADING = 'Create Brand',
  UPDATE_HEADING = 'Update Brand',
  LOADING_INDICATOR = 'Loading...',
  EMPTY_STRING = '',
  MODAL_WIDTH = 375,
}

export enum ValidationSchema {
  ERROR_MESSAGE = 'Required',
}
